import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../../components/Helpers/helpers";

export const billApi = createApi({
  reducerPath: "billApi",

  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
  }),

  tagTypes: ["Bills", "BillDetail"],

  endpoints: (builder) => ({
    //  GET BILL LIST
    getBillList: builder.query({
      query: (params = {}) => {
        const query = new URLSearchParams(params).toString();
        return `/invoice?${query}`;
      },
      providesTags: ["Bills"],
    }),

    //  GET BILL DETAIL
    getBillDetail: builder.query({
      query: (id) => `/invoice/invoice-detail/${id}`,
      providesTags: (r, e, id) => [{ type: "BillDetail", id }],
    }),

    //  UPDATE BILL LINE ITEM
    updateBillLineItem: builder.mutation({
      query: ({ InvoiceID, LineItemID, payload }) => ({
        url: `/invoice/${InvoiceID}/line-item/${LineItemID}`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["BillDetail"],
    }),

    //  UPDATE BILL DETAILS
    updateBillDetails: builder.mutation({
      query: ({ InvoiceID, payload }) => ({
        url: `/invoice/update-bill-details/${InvoiceID}`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["BillDetail"],
    }),

    //  UPDATE INVOICE USER
    updateInvoiceUser: builder.mutation({
      query: ({ InvoiceID, UserID, CurrentLoginedUserId, OrganisationID }) => ({
        url: `/invoice/update-invoice-user`,
        method: "POST",
        body: {
          type: "invoice",
          EntityID: InvoiceID,
          InvoiceID,
          UserID,
          CurrentLoginedUserId,
          OrganisationID,
          currentUserId: CurrentLoginedUserId,
        },
      }),
      invalidatesTags: ["Bills", "BillDetail"],
    }),

    //  READ BILL STATUS
    readBillStatus: builder.mutation({
      query: ({ id, user }) => ({
        url: `/invoice/read-invoice-status/${id}`,
        method: "POST",
        body: { user },
      }),
      invalidatesTags: ["BillDetail"],
    }),

    //  APPROVE BILL
    approveBill: builder.mutation({
      query: ({ InvoiceID, currentUserId }) => ({
        url: `/invoice/update-invoice-status`,
        method: "POST",
        body: { InvoiceID, currentUserId },
      }),
      invalidatesTags: ["Bills", "BillDetail"],
    }),

    //  VERIFY BILL
    verifyBill: builder.mutation({
      query: ({ InvoiceID, currentUserId }) => ({
        url: `/invoice/verified-invoice`,
        method: "POST",
        body: { InvoiceID, currentUserId },
      }),
      invalidatesTags: ["Bills", "BillDetail"],
    }),

    //  DELETE BILL
    deleteBill: builder.mutation({
      query: (InvoiceID) => ({
        url: `/invoice/delete-invoice-document`,
        method: "POST",
        body: { InvoiceID },
      }),
      invalidatesTags: ["Bills"],
    }),

    //  POST BILL ATTACHMENT
    postBillAttachment: builder.mutation({
      query: ({ InvoiceID, FileName }) => ({
        url: `/invoice/${InvoiceID}/Attachments/${FileName}`,
        method: "POST",
        body: { InvoiceID, FileName },
      }),
      invalidatesTags: ["Bills", "BillDetail"],
    }),
    //  MATCH BILL WITH TRANSACTION
    matchBill: builder.mutation({
      query: ({ TransactionID, InvoiceID, Amount }) => ({
        url: `/invoice/match-bill`,
        method: "POST",
        body: {
          TransactionID,
          InvoiceID,
          Amount,
        },
      }),
      invalidatesTags: ["Bills", "BillDetail"],
    }),
  }),
});

export const {
  useGetBillListQuery,
  useGetBillDetailQuery,
  useUpdateBillLineItemMutation,
  useUpdateBillDetailsMutation,
  useUpdateInvoiceUserMutation,
  useReadBillStatusMutation,
  useApproveBillMutation,
  useVerifyBillMutation,
  useDeleteBillMutation,
  usePostBillAttachmentMutation,
  useMatchBillMutation,
} = billApi;
